import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import {
  formatOrganizationSurveyTitle,
  getSurveyPeriodLabel,
} from "../../utils/organizationSurveyHelper";

const ReportSurveyHeader = ({ survey }) => {
  const location = useLocation();
  const payloadTitle = formatOrganizationSurveyTitle(survey || {});
  const stateTitle =
    location.state?.surveyTitle ||
    formatOrganizationSurveyTitle(location.state?.survey || {});
  const surveyTitle = getSurveyPeriodLabel(survey || {})
    ? payloadTitle
    : stateTitle || payloadTitle;

  if (!surveyTitle) return null;

  return (
    <Box mb={5}>
      <Text fontSize="sm" fontWeight="bold" color="gray.500" textTransform="uppercase">
        Survey
      </Text>
      <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="semibold">
        {surveyTitle}
      </Text>
    </Box>
  );
};

export default ReportSurveyHeader;
